import { CustomButtonProps } from '@/components/Button/Button';

export const buttonLogInProps: CustomButtonProps = {
  // variant: 'solid',
  w: 'full',
  fontWeight: 'normal',
};
